import type { FC } from 'react';
import React from 'react';

import { dataTestId } from '../../config';

interface IIconAssetGroupProps {
    className?: string;
}

export const IconAssetGroup: FC<IIconAssetGroupProps> = ({ className }) => (
    <svg
        className={className}
        data-test-id={dataTestId.iconLabel}
        fill="none"
        height="10"
        viewBox="0 0 14 10"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M14 9.5H0V4H5.31034V0.5H14V9.5Z" fill="white" />
    </svg>
);
